import { varGlobal } from "../shared/varGlobal";
import { Injectable } from "@angular/core";
import { AppSettingsService } from "./appsettings.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

/**
 *  Service de gestion des réponses aux Commandes HB
 */
@Injectable()
export class DetailedorderService extends BehaviorSubject<any[]> {
  /** Chemin vers l'API */
  public w_baseUrl: string = "";

  /**
   * Constructeur
   */
  constructor(
    public http: HttpClient,
    public s_appsettings: AppSettingsService,
    public s_global: varGlobal
  ) {
    super([]);
    this.w_baseUrl = this.s_global.pathAPI + "/detailedorder";
  }

  /**
   * Chargement de l'écran des Order Response (ORP)
   */
  public proc_getHBEcranOrp(
    i_tiers: number,
    f_activeEcran: boolean,
    w_msgN: string,
    i_msgId: number
  ): Observable<any> {
    if (f_activeEcran) return this.proc_getHBDetailedOrder(i_tiers, w_msgN);
    else return this.proc_getHBVisuOrp(i_tiers, i_msgId);
  }

  /**
   * Fonction de SAISIE d'un Order Response (chargement d'infos)
   */
  public proc_getHBDetailedOrder(
    i_tiers: number,
    w_msgN: string
  ): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getHBDetailedOrder`,
      JSON.stringify({
        tiersId: i_tiers,
        msgN: w_msgN
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de VISU d'un Order Response
   */
  public proc_getHBVisuOrp(i_tiers: number, i_msgId: number): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getHBVisuOrp`,
      JSON.stringify({
        tiersId: i_tiers,
        msgId: i_msgId
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de sauvegarde d'un Order Response
   */
  public proc_setHBDetailedOrder(
    i_tiers: number,
    h_data: any
  ): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/setHBDetailedOrder`,
      JSON.stringify({
        tiersId: i_tiers,
        jsonDetailedOrder: JSON.stringify(h_data)
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/detailedorder.service.ts